import React, { FC } from 'react';
import { TrackerUtil } from '../../../../../tracking/TrackerUtil';
import InlineLink from './styled-components/InlineLink';
import useBreakPoints from '../../../../../interface_adapters/hooks/useBreakPoints';

interface AgbInlineLinkProps {
  linkText: string;
  handleOpenAgbInModal: () => void;
  handleOpenAgbViaWindow: () => void;
}

const AgbInlineLink: FC<AgbInlineLinkProps> = ({
  linkText,
  handleOpenAgbInModal,
  handleOpenAgbViaWindow
}) => {
  const { isMobile } = useBreakPoints();
  return (
    <InlineLink
      tabIndex={0}
      onClick={(event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        event.preventDefault(); // User clicked on link, so don't tick the box.
        TrackerUtil.trackLinkClick(`${TrackerUtil.getPageName()}_link_agb`, 'link_agb');
        isMobile ? handleOpenAgbInModal() : handleOpenAgbViaWindow();
      }}
      onKeyDown={(event: React.KeyboardEvent<HTMLSpanElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          TrackerUtil.trackLinkClick(`${TrackerUtil.getPageName()}_link_agb`, 'link_agb');
          handleOpenAgbViaWindow();
        }
      }}
    >
      {linkText}
    </InlineLink>
  );
};

export default AgbInlineLink;
